/**
 * Created by wangmeng on 2017/5/15.
 */
import {Injectable} from '@angular/core';
import {Http} from '@angular/http';

import {Observable} from 'rxjs/Rx';
import 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

export class UserServiceConfig {
  userName = 'wang meng';
}

export class UserInfo {
  constructor(public  accountId: number,
              public  nickname: string,
              public  portrait: string) {
  }
}
@Injectable()
export class AuthService {

  isLoggedIn: boolean = false;

  redirectUrl: string = '';

  private login = '/public/api/user';
  private logout = '/auth/logout';

  constructor(private http: Http) {

  }

  authLogin(username, password, data?): Observable<UserInfo> {
    let params = {'remember-me': data};
    let body = {
      'username': username,
      'password': password
    };
    return this.http
      .post(this.login, body, params)
      .map(res => res.json() as UserInfo)
      .catch(this.loginHandleError);
  }

  checkLogin(): Observable<UserInfo> {
    return this.http
      .get(this.login)
      .map(res => res.json().content as UserInfo)
      .catch(this.loginHandleError);
  }

  authLogout(): Observable<UserInfo> {
    return this.http
      .get(this.logout)
      .map(res => res.json() as UserInfo)
      .catch(this.handleError);
  }

  private handleError(error: any) {
    let errMsg = (error.message) ? error.message : error.status ? `${error.status} - ${error.statusText}` : error;
    return Observable.throw(errMsg);
  }

  private loginHandleError(error: any) {
    let errMsg = error.json();
    return Observable.throw(errMsg);
  }

}



// WEBPACK FOOTER //
// ./src/app/core/auth.service.ts